import { useControlled } from "@commonlibs";
import { useState } from "react";
import { FileUploadProps } from "../../../FileUpload/FileUpload.types";
import { UploadedFile } from "../../../UploadInput/UploadInput.types";
import { UseSingleImageUploadParams, UseSingleImageUploadReturn } from "./useSingleImageUpload.types";

export default function useSingleImageUpload<Multiple extends boolean = false>({
    onChange,
    value,
    defaultValue,
    onError,
    onSuccess,
}: UseSingleImageUploadParams<Multiple>): UseSingleImageUploadReturn<Multiple> {
    const [file, setFile] = useControlled<FileUploadProps<Multiple>["value"]>(defaultValue, value, onChange);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleRemoteUploadStart = () => {
        setLoading(true);
        setError(false);
        setSuccess(false);
    };

    const handleRemoteUploadEnd = () => {
        setLoading(false);
    };

    const handleOnError = (error?: unknown) => {
        setError(true);
        onError?.(error);
    };

    const handleOnSuccess = (file: UploadedFile) => {
        setSuccess(true);
        onSuccess?.(file);
    };

    return {
        value: file,
        onChange: setFile,
        error,
        loading,
        success,
        onUploadStart: handleRemoteUploadStart,
        onUploadEnd: handleRemoteUploadEnd,
        onError: handleOnError,
        onSuccess: handleOnSuccess,
    };
}
